import {FunnyItem, HighlightRow, IBattle, Stage, VideoFile} from "../10. Battle/types";
import Dialog from "../1. Core/Controls/Dialog/Dialog";
import TextField from "../1. Core/Controls/TextField/TextField";
import IconToggleButton from "../1. Core/Controls/IconToggleButton/IconToggleButton";
import NP from "../1. Core/NP";
import {downloadVideoFile} from "../10. Battle/Util";
import SegmentDP from "./SegmentDP";
import DataTable from "../1. Core/Controls/DataTable/DataTable";
import {MAIN_SERVER_URL} from "./types";
import {IItem} from "../1. Core/Controls/ListBox/ListItem";
import Delegate from "../1. Core/Delegate";

let moment = require('moment');


export function showShareDialog(item: VideoFile)
{
	let origin = window.location.href.indexOf(".bd-sport.com") > -1 ? MAIN_SERVER_URL : window.location.origin
	let dlg = new Dialog({
		Content: [
			new TextField({
				FloatingLabel: 'Download link',
				Value: `${origin}/video/${item.FileId}.mp4?f=${encodeURIComponent(item.Name)}`,
				Width: 336
			}),
			new IconToggleButton({
				FontImage: NP.FontImages.download,
				EvClick: () =>
				{
					if (window.location.href.indexOf(".bd-sport.com") > -1)
						downloadVideoFile(`${item.FileId}`, item.Name, null)
					else
						NP.downloadFile(`/ui-api/video/getFile/${item.FileId}`);
				}
			}),
			new TextField({FloatingLabel: 'View link', Value: `${origin}/video/${item.FileId}.mp4`})
		]
	})

	let btn = dlg.getContent()[1]
	btn.getRoot().style.position = 'relative'
	btn.getRoot().style.top = '45px'

	dlg.getCancelButton().hide();
	dlg.show();
}

let playTimeId;

export function createFunnyRow(f: FunnyItem, isRed: boolean = true)
{
	let m = moment(f.HighlightDate, 'YYYY-MM-DD HH:mm:ss.SSS')
	return {
		Id: f.Id,
		Time: f.HLTime,
		HLDesc: f.Action,
		WorldTime: m.toDate(),
		WorldTimeStr: m.format('HH:mm:ss'),
		PrevNext: `-${f.TimeInfo.PrevSeconds} + ${f.TimeInfo.NextSeconds}`,
		FunnyEvent: f,
		CssClass: isRed ? 'red-row' : 'blue-row'
	}
}

export function showSegmentMenu(battleEvent: HighlightRow | FunnyItem,
										  videNode: HTMLVideoElement,
										  contextNode: HTMLElement,
										  dataTable: DataTable,
										  videoStartTime: string,
										  createRow: Function,
										  calcVideoPointPosition?: Function,
										  orderListClick: Delegate = null,
										  evChanged: Delegate = null)
{

	let actionts = (battleEvent as HighlightRow).ActionTS || (battleEvent as FunnyItem).HighlightDate

	let sdp = new SegmentDP({
		Event: battleEvent,
		VideoNode: videNode,
		EvOrderListClick: orderListClick,
		EvFromStartPlay: async () =>
		{
			clearTimeout(playTimeId)
			videNode.currentTime = getPointTimeFromWT(actionts, videoStartTime) - battleEvent.TimeInfo.PrevSeconds;
			await videNode.play();
			playTimeId = setTimeout(() => videNode.pause(), 1000 * (battleEvent.TimeInfo.PrevSeconds + battleEvent.TimeInfo.NextSeconds));
		},
		EvFromPointPlay: async () =>
		{
			clearTimeout(playTimeId)
			videNode.currentTime = getPointTimeFromWT(actionts, videoStartTime);
			await videNode.play();
			playTimeId = setTimeout(() => videNode.pause(), 1000 * battleEvent.TimeInfo.NextSeconds);
		},
		EvChanged: () =>
		{
			clearTimeout(playTimeId)
			if (calcVideoPointPosition)
				calcVideoPointPosition(contextNode, battleEvent, videNode.duration)

			let row = dataTable.getRows().find((it: any) =>
			{
				if (it.MMAEvent)
					return it.EventOrder == (battleEvent as HighlightRow).EventOrder
				else if (it.FunnyEvent)
					return it.FunnyEvent.Id == (battleEvent as FunnyItem).Id;
				else
					return false
			})

			if (row)
			{
				let newRow = (battleEvent as HighlightRow).ActionTS ? createRow(battleEvent as HighlightRow) : createFunnyRow(battleEvent as FunnyItem)

				for (let key in row)
					row[key] = newRow[key]

				dataTable.updateRow(row)
			}

			if (evChanged)
				evChanged.fire(battleEvent)
		}
	});
	NP.showDropPanel(sdp, contextNode, NP.LTRB.Bottom);
}

export function getPointTimeFromWT(actionTSStr: string, videoStartTime: string): number
{

	let wtVideoStart = moment(videoStartTime, 'YYYY-MM-DD HH:mm:ss.SSS').toDate().getTime()
	let actionTS = moment(actionTSStr, 'YYYY-MM-DD HH:mm:ss.SSS').toDate().getTime()

	return (actionTS - wtVideoStart) / 1000;
}

export function getBattleMenuItems(battles: IBattle[]): IItem[]
{
	let mainCardList = battles.filter(b => b.Stage == Stage.Maincard).map((b) => ({
		Value: b,
		IsCheckBox: true,
		Content: b.RedName + ' vs ' + b.BlueName
	}));

	let prelimsList = battles.filter(b => b.Stage == Stage.Prelims).map((b, idx) => ({
		Value: b,
		IsCheckBox: true,
		Content: b.RedName + ' vs ' + b.BlueName
	}));

	let earlyList = battles.filter(b => b.Stage == Stage.EarlyPrelims).map((b, idx) => ({
		Value: b,
		IsCheckBox: true,
		Content: b.RedName + ' vs ' + b.BlueName
	}));

	let otherList = battles.filter(b => b.Stage != Stage.Maincard && b.Stage != Stage.Prelims && b.Stage != Stage.EarlyPrelims).map((b, idx) => ({
		Value: b,
		IsCheckBox: true,
		Content: b.RedName + ' vs ' + b.BlueName
	}));

	let items = []

	if (mainCardList.length)
		items.push({IsHeader: true, Content: Stage.Maincard}, ...mainCardList)

	if (prelimsList.length)
		items.push({IsHeader: true, Content: Stage.Prelims}, ...prelimsList)

	if (earlyList.length)
		items.push({IsHeader: true, Content: Stage.EarlyPrelims}, ...earlyList)

	if (otherList.length)
		items.push({IsHeader: true, Content: 'Other'}, ...otherList)

	return items;
}